import styled from "styled-components";

export default function NoticeDetail({ info }) {
  return (
    <Wrapper>
      <div className="title">{info.title}</div>
      <div className="time">{info.create_time.split(" ")[0]}</div>
      <div className="content">{info.content}</div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 2.0rem;
  .title {
    font-weight: 700;
    font-size: 2.0rem;
    line-height: 2.0rem;
    color: #000000;
    font-stretch: 95;
    text-align: center;
  }
  .time {
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #969696;
    text-align: right;
    margin: 2.0rem 0 2.0rem;
  }
  .content {
    font-style: normal;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: #000000;
  }
`;
